import * as z from 'zod';

export const PROFILE_SOURCES = [
  'Internal Referral',
  'External Referral',
  'LinkedIn',
  'LinkedIn Headhunting',
  'Career Page',
  'ATS',
];

/** Candidate fields shared by the potential-profile and conditional-offer forms. */
export const candidateFormSchema = z.object({
  FirstName: z.string().min(1, { message: 'FIRST_NAME_REQUIRED' }),
  LastName: z.string().min(1, { message: 'LAST_NAME_REQUIRED' }),
  PhoneNumber: z.string().min(1, { message: 'PHONE_NUMBER_REQUIRED' }),
  Email: z
    .string()
    .min(1, { message: 'EMAIL_REQUIRED' })
    .email({ message: 'INVALID_EMAIL_ADDRESS' }),
  Source: z.string().min(1, { message: 'SOURCE_REQUIRED' }),
  YearsOfExperience: z.coerce.number().min(0, { message: 'YEARS_OF_EXPERIENCE_MUST_BE_POSITIVE' }),
  Designation: z.string().min(1, { message: 'DESIGNATION_REQUIRED' }),
  Comment: z.string().optional(),
});

export type CandidateFormValues = z.infer<typeof candidateFormSchema>;

export const candidateFormDefaults: CandidateFormValues = {
  FirstName: '',
  LastName: '',
  PhoneNumber: '',
  Email: '',
  Source: PROFILE_SOURCES[0],
  YearsOfExperience: 0,
  Designation: '',
  Comment: '',
};
